function supara_newsletter(email) {
    var myHeaders = new Headers();
    myHeaders.append("api-key", "4940F195-2EAD-42A1-84FE-55A6B4416FE6");
    myHeaders.append("client", "magenest");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "profiles": [
            {
                "email": email
            }
        ]
    });

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch("https://dev.api.backend.gw.int.suparagroup.com/gq-connect/webhooks/shopify/receive/subscribe/newsletter", requestOptions)
        .then(response => response.json())
        .then(data => {
            console.log(data);
        })
        .catch(error => console.log('error', error));
}


function instantAgree() {

    // console.log('agree submit button clicked');
    var emailAddress = $('.form-emailaddress').val();
    // console.log('emailAddress==>'+emailAddress);
    if (emailAddress) {
        supara_newsletter(emailAddress);
        isChecked = $('#agree').is(':checked');
        //console.log('isChecked==>'+isChecked);
        if (isChecked) {
            //console.log(' form success');
            $('.home-newsletter-signup').trigger('submit');
        } else {
            //console.log('checkbox error');
            $(".home-newsletter-signup .signup-form").after("<p class='error'>Please select the checkbox and try again</p>");
            setTimeout(function () {
                $(".home-newsletter-signup .error").remove();
            }, 3000);
            return false;
        }
    } else {
        //console.log('email error');
        $(".home-newsletter-signup .signup-form").after("<p class='error'>Email - can't be blank</p>");
        setTimeout(function () {
            $(".home-newsletter-signup .error").remove();
        }, 3000);
        return false;
    }

}

function instantFooterAgree() {

    // console.log('agree submit button clicked');
    var emailAddress = $('.footer_newsletter_signup .form-emailaddress').val();
    // console.log('emailAddress==>'+emailAddress);
    if (emailAddress) {
        supara_newsletter(emailAddress);
        isChecked = $('.footer_newsletter_signup #agree').is(':checked');
        //console.log('isChecked==>'+isChecked);
        if (isChecked) {
            //console.log(' form success');
            $('.footer_newsletter_signup').trigger('submit');
        } else {
            //console.log('checkbox error');
            $(".section-footer__newsletter-block .signup-form").after("<p class='error'>Please select the checkbox and try again</p>");
            setTimeout(function () {
                $(".section-footer__newsletter-block .error").remove();
            }, 5000);
            return false;
        }
    } else {
        //console.log('email error');
        $(".section-footer__newsletter-block .signup-form").after("<p class='error'>Email - can't be blank</p>");
        setTimeout(function () {
            $(".section-footer__newsletter-block .error").remove();
        }, 5000);
        return false;
    }

}

function popupInstantAgree() {

    console.log('popupagree submit button clicked');
    var emailAddress = $('.cc-popup-form-input').val();
    console.log('emailAddress==>' + emailAddress);
    if (emailAddress) {
        supara_newsletter(emailAddress);
        isChecked = $('.newsletter-popup #agree').is(':checked');
        console.log('isChecked==>' + isChecked);
        if (isChecked) {
            console.log(' form success');
            $('.newsletter-popup').trigger('submit');
        } else {
            console.log('checkbox error');
            $(".newsletter-popup .cc-popup-form-buttons").after("<div class='cc-popup-form__response cc-popup-form__response--error error'><p class='error'>Please select the checkbox and try again</p></div>");
            setTimeout(function () {
                $(".newsletter-popup .cc-popup-form__response--error").remove();
            }, 3000);
            return false;
        }
    } else {
        //console.log('email error');
        $(".newsletter-popup .cc-popup-form-buttons").after("<div class='cc-popup-form__response cc-popup-form__response--error error'><p class='error'>Email - can't be blank</p></div>");
        setTimeout(function () {
            $(".newsletter-popup .cc-popup-form__response--error").remove();
        }, 3000);
        return false;
    }

}


